import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';

import { InactiveTenantWarning } from '@/console/features/tenant/components/inactive-tenant-warning/inactive-tenant-warning';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { TenantProvider } from '@/shared/features/auth/context/tenant-context';
import { AcceptPrivacyPolicy } from '@/shared/features/rbac/components/accept-privacy-policy/accept-privacy-policy';
import { EnforceMfaWarning } from '@/shared/features/rbac/components/enforce-mfa-warning/enforce-mfa-warning';
import { SwitchTenantInfo } from '@/shared/features/rbac/components/switch-tenant-info/switch-tenant-info';
import { useTermsAndConditions } from '@/shared/hooks/use-terms-and-conditions/use-terms-and-conditions';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const AuthenticatedRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const user = useAppSelector(selectUser);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // Block the authenticated app until the terms acceptance status is known.
  const { isLoading: isLoadingTerms } = useTermsAndConditions();

  if (!user) {
    let to = `/auth/login`;
    const company = searchParams.get('company');

    if (company) {
      to += `?company=${company}`;
    }

    return <Navigate to={to} state={{ from: location }} replace />;
  }

  if (isLoadingTerms) {
    return <FullscreenLoader />;
  }

  return (
    <TenantProvider>
      {children}
      <SwitchTenantInfo />
      <AcceptPrivacyPolicy />
      <EnforceMfaWarning />
      <InactiveTenantWarning />
    </TenantProvider>
  );
};
